<template>
  <b-overlay variant="success" opacity="0.5" :show="wait">
    <b-modal id="modalPago" >
      <template #modal-header>
        Pago
      </template>
      <b-form-group label="Monto">
        <b-input autofocus v-model="MontoPago" type="number"></b-input>
      </b-form-group>

      <template #modal-footer>
        <b-button @click="$bvModal.hide('modalPago')">Cerrar</b-button>
        <b-button @click="Pagar">Pagar</b-button>
      </template>
    </b-modal>
    <b-card no-body>
      <b-tabs card>
        <b-tab title="Clientes" active>
          <b-container>
            <b-form-group label="Cliente">
              <v-select @search="onSearch" label="Nombre" class="w-100" v-model="selCliente" :options="autoClientes">
                <template v-slot:no-options="{ search, searching }">
                  <template v-if="searching">
                    No existen clientes con el nombre: <em>{{ search }}</em> .
                  </template>
                  <em v-else style="opacity: 0.5"> Escriba para buscar un cliente!</em>
                </template>
              </v-select>
            </b-form-group>

            <div v-if="!selCliente == false && !selCliente.Value == false">
              <b-row>
                <b-col lg="6">
                  <b-card class="my-1 p-1" title="Datos Cliente">
                    <b-input-group class="my-2" prepend="Nombre">
                      <b-input v-model="selCliente.Nombre" :formatter="formatear"></b-input>
                    </b-input-group>

                    <b-input-group class="my-2" prepend="Documento">
                      <b-input v-model="selCliente.Identificacion"></b-input>
                    </b-input-group>
                    <b-input-group variant="success" class="my-2">
                      <template #prepend>
                        <b-input-group-text class="bg-success text-white"> Deuda </b-input-group-text>
                      </template>

                      <label class="form-control" v-html="selCliente.Deuda"></label>
                    </b-input-group>
                    <b-input-group class="my-2" prepend="Celular">
                      <b-input v-model="selCliente.Celular"></b-input>
                    </b-input-group>
                    <b-input-group class="my-2" prepend="Direccion">
                      <b-input v-model="selCliente.Direccion"></b-input>
                    </b-input-group>

                    <b-input-group class="my-2" prepend="Region">
                      <b-form-select class="form-control" v-model="selCliente.Region" :options="Regiones"></b-form-select>
                    </b-input-group>

                    <template #footer>
                      <b-button v-show="!selCliente.Deuda == false" variant="success" v-b-modal.modalPago>Pago</b-button>
                      <b-button @click="Actualizar" variant="primary" class="mx-2">Actualizar</b-button>
                    </template>
                  </b-card>
                </b-col>
                <b-col lg="6" class="my-2 text-center">
                  <b-button v-if="!MisEnvios.length" @click="verEnvios" variant="primary" class="w-50">Ver Envios</b-button>

                  <div v-else>
                    <b-table-lite small striped bordered :items="MisEnvios" :fields="campos">
                      <template #cell(Op)="row">
                        <b-button @click="preview(row.item.Id)" size="sm" variant="primary" pill> Recibo </b-button>
                      </template>
                    </b-table-lite>
                  </div>
                </b-col>
              </b-row>
            </div>
          </b-container>
        </b-tab>
        <b-tab title="Saldos">

          <b-table-lite bordered striped small :items="SaldosCli" :fields="['Nombre','Celular','Deuda']"></b-table-lite>

        </b-tab>
        <b-tab title="Nuevo">
          <b-form inline>
            <b-input-group prepend="Nombre: ">
              <b-form-input v-model="Nuevo.Nombre" placeholder="Nombre del cliente" />
            </b-input-group>

            <b-input-group class="my-2" prepend="Docuemento: ">
              <b-form-input v-model="Nuevo.Identificacion" placeholder="Identificación" />
            </b-input-group>

            <b-input-group class="my-2" prepend="Dirección:">
              <b-input v-model="Nuevo.Direccion" placeholder="Domicilio del cliente"></b-input>
            </b-input-group>

            <b-input-group class="my-2" prepend="Celular:">
              <b-form-input v-model="Nuevo.Celular" placeholder="Numero de celular"></b-form-input>
            </b-input-group>

            <b-input-group class="my-2" prepend="Region:">
              <b-form-select class="form-control" v-model="Nuevo.Region" id="region" :options="Regiones"></b-form-select>
            </b-input-group>
          </b-form>

          <b-card-footer>
            <b-button :disabled="!PuedoGuardar" @click="onGuardar" variant="success">Guardar</b-button>
          </b-card-footer>
        </b-tab>
      </b-tabs>
    </b-card>
  </b-overlay>
</template>

<script>
import firebase from "firebase/app";
import "firebase/firestore";

if (!firebase.apps.length) firebase.initializeApp({ projectId: "diazvelizexpress" });
else firebase.app();

const db = firebase.firestore();

function formatDate(date) {
  var d = new Date(date),
    month = "" + (d.getMonth() + 1),
    day = "" + d.getDate(),
    year = d.getFullYear();

  if (month.length < 2) month = "0" + month;
  if (day.length < 2) day = "0" + day;

  return [year, month, day].join("-");
}

function quitarAcentos(cadena) {
  const acentos = { á: "a", é: "e", í: "i", ó: "o", ú: "u", Á: "A", É: "E", Í: "I", Ó: "O", Ú: "U" };
  return cadena
    .split("")
    .map((letra) => acentos[letra] || letra)
    .join("")
    .toString();
}

export default {
  mounted() {
    
    let viajes = localStorage.Viajes || "[]";

    this.Viajes = JSON.parse(viajes);
    this.wait = false;
  },
  methods: {
    Pagar() {
      this.wait = true;
      let id = this.selCliente.Value;
      let saldo = this.selCliente.Deuda - this.MontoPago;

      db.collection("Cliente")
        .doc(id)
        .update({ Deuda: saldo })
        .then(() => {
          this.$bvModal.msgBoxOk("Pago recibido");
          this.selCliente = {};
          this.$bvModal.hide("modalPago");
          this.wait = false;
        });
    },
   
    Preview(envio) {
      let env = {
        ...this.Envios.filter((d) => {
          return d.id == envio;
        }),
      }[0];

      env.Remitente = this.Clientes.filter((cli) => cli.id == env.Envia)[0];
      env.Destinatario = this.Clientes.filter((cli) => cli.id == env.Recibe)[0];

      localStorage.Paquete = JSON.stringify(env);
      localStorage.Viaje = JSON.stringify(this.Viajes[0]);

      window.open("/Paquete", "_blank");
    },
    verEnvios() {
      let self = this;
      let id = this.selCliente.Value;
      let qr = this.Envios.filter((envio) => envio.Envia == id || envio.Recibe == id)
        .sort((a, b) => {
          return b.Fecha - a.Fecha;
        })
        .map((item) => {
          return {
            Cliente: item.Envia == id ? self.Clientes.filter((cli) => cli.id == item.Recibe)[0].Nombre : self.Clientes.filter((cli) => cli.id == item.Envia)[0].Nombre,
            Fecha: formatDate(item.Fecha.toDate()),
            Contenido: item.Contenido,
            Paquetes: item.Contenido.filter((cnt) => cnt.Tipo == "Paquete").length,
            Id: item.id,
          };
        });

      this.MisEnvios = qr;

      if(qr.length==0) {
        this.$bvModal.msgBoxOk('No hay informacion!')
      }


    },
    Actualizar() {
      let self = this;
      let dato = { ...this.datoUpdate };
      db.collection("Cliente")
        .doc(this.selCliente.Value)
        .update(dato)
        .then(() => {
          self.selCliente = {};
        });
    },
    formatear(v) {
      v = quitarAcentos(v.toUpperCase());
      return v;
    },
    reg(txt) {
      let r = "";
      txt.split(" ").forEach((p) => {
        r += "(?=.*" + p + ")";
      });
      return r + ".*";
    },
    onSearch(qr) {
      if (qr) {
        this.MisEnvios = [];
        qr = this.reg(qr.toUpperCase());
        let txt = new RegExp(qr, "gmi");

        let datos = this.Clientes.filter((r) => {
          return txt.test(r.Nombre.toUpperCase());
        })
          .slice(0, 10)
          .map((r) => {
            return { ...r, Value: r.id };
          });

        this.autoClientes = datos;
      }
    },
    onGuardar() {
      this.Nuevo.Nombre = quitarAcentos(this.Nuevo.Nombre.toUpperCase());
      let self = this;

      db.collection("Cliente")
        .add(this.Nuevo)
        .then(() => {
          self.Nuevo = { Nombre: "", Direccion: "", Celular: "", Region: "", Deuda: 0, Identificacion: "" };
        });
    },
    preview(n) {
      localStorage.removeItem("Envio");

      let env = {
        ...this.Envios.filter((d) => {
          return d.id == n;
        }),
      }[0];

      env.Remitente = this.Clientes.filter((p) => p.id == env.Envia)[0];
      env.Destinatario = this.Clientes.filter((p) => p.id == env.Recibe)[0];

      localStorage.Paquete = JSON.stringify(env);
      localStorage.Viaje = JSON.stringify(this.Viajes[0]);
      
      window.open("/Envio", "_blank");

    },
  },
  watch:{
    selCliente(){
      this.MisEnvios = [];
    }
  },
  data() {
    return {
      min:false,
      MontoPago: null,
      campos: ["Fecha", "Cliente", "Op"],
      selCliente: {},
      wait: true,
      qr: null,
      Clientes: null,
      Paises: null,
      Nuevo: { Nombre: "", Direccion: "", Celular: "", Region: null, Deuda: 0, Identificacion: "" },
      Texto: null,
      autoClientes: [],
      Envios: [],
      Viajes: [],
      MisEnvios: [],
    };
  },
  firestore: {
    Paises: db.collection("Pais"),
    Clientes: db.collection("Cliente"),
    Envios: db.collection("Envios"),

  },
  computed: {
    SaldosCli(){
      let cli = this.Clientes.filter(cli=>{ return cli.Deuda>0 });

      return cli;
    },
    datoUpdate() {
      let tmp = { ...this.selCliente };

      delete tmp.Value;
      return tmp;
    },
    PuedoGuardar() {
      let validos = 0;
      if (this.Nuevo.Nombre !== "") validos++;
      if (this.Nuevo.Direccion !== "") validos++;
      if (this.Nuevo.Celular !== "") validos++;
      if (this.Nuevo.Region !== null) validos++;

      return validos == 4;
    },
    Regiones() {
      let rs = this.Paises.map((p) => {
        return {
          label: p.Nombre,
          options: p.Regiones.map((r) => {
            return { value: r.Codigo, text: r.Nombre };
          }),
        };
      });
      return rs;
    },
  },
};
</script>
<style scoped>
.input-group-text {
  width: 120px !important;
}
.card-footer {
  text-align: right;
}
</style>
